import SuccessIcon from "../../assets/success.svg";
import WarningIcon from "../../assets/warning.svg";
import DeleteIcon from "../../assets/delete.svg";

import CreateModal from "./create-modal";

import "./Modal.css";

const VocsModal = {
  success: CreateModal({
    defaultTitle: "Complete",
    defaultMessage: "Update Successfully",
    icon: SuccessIcon,
    defaultShowFooter: false,
    defaultCloseAfter: 3000,
  }),
  warning: CreateModal({
    defaultMessage: "Want to save your changes before canceling the selected app?",
    icon: WarningIcon,
    defaultOnlyYes: true,
  }),
  error: CreateModal({
    defaultMessage: "Something went wrong",
    defaultTitle: "Error",
    icon: WarningIcon,
    defaultOnlyYes: true,
  }),
  delete: CreateModal({
    defaultTitle: "Do you want to delete?",
    defaultYesText: "Delete",
    defaultMessage: "",
    icon: DeleteIcon,
  }),
};

export default VocsModal;
